// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".prueba {\n  width: 100%;\n}\n[dir] .vs-button:not(.vs-radius):not(.includeIconOnly):not(.small):not(.large) {\n  padding: -0.25rem 2rem;\n  margin: 10px;\n}\n[dir] .btn-group button {\n  /*padding: 1rem 1.25rem !important;*/\n  padding: 6px !important;\n}\n.form-error-message {\n  font-size: 0.6vw !important;\n}\n[dir=ltr] .form-error-message {\n  float: right;\n}\n[dir=rtl] .form-error-message {\n  float: left;\n}\n", ""]);
// Exports
module.exports = exports;
